export const APP_ROUTES = {
  HOME: '/',
  MODS: '/mods',
  VR_MODS: '/vr-mods',
  UEVR_MODS: '/uevr-mods',
  HEAD_TRACKING_MODS: '/head-tracking-mods',
  PROFILE: '/profile/:id',
  GAMES: '/games',
  GAME_PROFILE: '/games/:id',
  SIMRLABS: '/simrlabs',
  PRIVACY: '/privacy',
} as const;

export type AppRouteKey = keyof typeof APP_ROUTES;
export type AppRoutePath = (typeof APP_ROUTES)[AppRouteKey];

export const getProfileRoute = (id: string): string => `/profile/${encodeURIComponent(id)}`;
export const getGameProfileRoute = (id: string): string => `/games/${encodeURIComponent(id)}`;
